import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-criminal-queries',
  templateUrl: './criminal-queries.component.html',
  styleUrls: ['./criminal-queries.component.css']
})
export class CriminalQueriesComponent implements OnInit {
    title="Criminal Report For Internal Security Division";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/staff-criminal-proceedings/criminal-queries/criminal-queries.component.ts